import { create } from "zustand";

/**
 * Context Drawer Store - Manages state for the dynamic context drawer
 * 
 * The drawer automatically appears when sovereign/compliance/trading panels are open,
 * showing AI-generated contextual information, KPIs, EU taxonomy references, and
 * remediation suggestions.
 */
export interface ContextDrawerState {
  /** Whether the drawer is enabled and should be visible */
  enabled: boolean;
  /** Currently active route/panel identifier */
  activeRoute: string | null;
  /** Snapshot of input values when last context was fetched */
  inputSnapshot: Record<string, number | string>;
  /** Timestamp of last context fetch */
  lastFetch: Date | null;
  /** Whether the drawer is currently open/visible */
  open: boolean;

  /** Actions */
  setEnabled: (enabled: boolean) => void;
  setActiveRoute: (route: string | null) => void;
  updateInputSnapshot: (inputs: Record<string, number | string>) => void;
  setLastFetch: (date: Date | null) => void;
  toggle: () => void;
  openDrawer: () => void;
  closeDrawer: () => void;
}

/**
 * Zustand store for Context Drawer state management
 */
export const useContextDrawerStore = create<ContextDrawerState>((set) => ({
  enabled: true,
  activeRoute: null,
  inputSnapshot: {},
  lastFetch: null,
  open: false,

  setEnabled: (enabled) => set({ enabled }),
  setActiveRoute: (activeRoute) => set({ activeRoute }),
  updateInputSnapshot: (inputSnapshot) => set({ inputSnapshot }),
  setLastFetch: (lastFetch) => set({ lastFetch }),
  toggle: () => set((state) => ({ open: !state.open })),
  openDrawer: () => set({ open: true }),
  closeDrawer: () => set({ open: false }),
}));











